import { createFileRoute, Link } from "@tanstack/react-router";
import { MarketingShell, M } from "@/components/MarketingShell";
import { BLOG_POSTS } from "@/content/blog";

const DESC =
  "Practical, honest guides for students on AI rules, referencing and what markers look for — from Tiger's Eye.";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "Blog — study guides from Tiger's Eye" },
      { name: "description", content: DESC },
      { property: "og:title", content: "Blog — study guides from Tiger's Eye" },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://tigerseye.app/blog" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://tigerseye.app/blog" }],
  }),
  component: BlogIndex,
});

function BlogIndex() {
  return (
    <MarketingShell>
      <p className="text-xs uppercase tracking-[0.2em]" style={{ color: M.BRASS }}>Blog</p>
      <h1 className="mt-3 text-4xl" style={{ fontFamily: M.SERIF }}>Guides for better drafts</h1>
      <p className="mt-4" style={{ color: M.INK_SOFT }}>{DESC}</p>
      <ul className="mt-10 divide-y" style={{ borderColor: M.RULE }}>
        {BLOG_POSTS.map((p) => (
          <li key={p.slug} className="py-6" style={{ borderColor: M.RULE }}>
            <Link to="/blog/$slug" params={{ slug: p.slug }} className="group block">
              <h2 className="text-2xl group-hover:underline" style={{ fontFamily: M.SERIF, color: M.INK }}>
                {p.title}
              </h2>
              <p className="mt-2 text-sm" style={{ color: M.INK_SOFT }}>{p.description}</p>
              <p className="mt-2 text-xs" style={{ color: M.INK_FAINT }}>
                {p.date} · {p.readMinutes} min read
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </MarketingShell>
  );
}
